
import React, { useState, useEffect } from 'react';
import '../css/dataTablePopUp.css';

const FilterPopupComponent = ({ onClose, onRemoveTable, nodeName, selectedNodeId, onValueSubmit,
  nodes, setNodes, edges, setEdges, droppedNodes, setDroppedNodes, data, selectedPreviousTable,
  selectedCurrentTable, firstColumn, firstCompareToValue,
  columns,
  connectionValue,
  firstEnterValue,
  groupEnterValue,
  selectedGroupColumnValue, additionalCompareTypeValues,
  showAdditionalinputGrouplength, additionalLogicalOperatorsValue, buttonValue,
  selectedDatabase, catalog, columnTypeList,
  aliasColumn, windowFunctionWithCondition,
  secondEnteredValue, connectionType, filterColumn
}) => {

  console.log("filterColumn::13", filterColumn);

  let columnsDataValues;

  if (columns && columns.length > 1) {
    columnsDataValues = [].concat(...columns);
  } else {
    columnsDataValues = columns[0];
  }

  console.log("columnsDataValues::1",firstColumn, columnsDataValues,selectedDatabase,connectionType);
  /*
  //columnsDataValues.map (elem=>  "json_extract_scalar(" + elem + ")");
  columnsDataValues.forEach((element, index) => {
    columnsDataValues[index] = "json_extract_scalar(" + element + ")"; // Update element at index
  });
  console.log(JSON.stringify(columnsDataValues) + selectedDatabase + " " + connectionType + "columnsDataValues");
 */
  
  const dropdownCompareToOptions = [
    { value: 'EqualTo', label: 'is equal to', symbol: '=' },
    { value: 'DoesNotEqual', label: 'is not equal to', symbol: '!=' },
    { value: 'GreaterThan', label: 'is greater than', symbol: '>' },
    { value: 'GreaterThanOrEqualTo', label: 'is greater than or equal to', symbol: '>=' },
    { value: 'LessThan', label: 'is less than', symbol: '<' },
    { value: 'LessThanOrEqualTo', label: 'is less than or equal to', symbol: '<=' },
    { value: 'IsEmpty', label: 'is empty', symbol: '' },
    { value: 'IsNotEmpty', label: 'is not empty', symbol: '' },
    { value: 'BETWEEN', label: 'Between', symbol: 'BETWEEN' },
  ];

  const dropdownLogicalOperator = [
    { value: 'and', label: 'AND' },
    { value: 'or', label: 'OR' }
  ];

  const [isChecked, setIsChecked] = useState(false);
  const [name, setName] = useState(nodeName);
  const [enterValue, setEnterValue] = useState(firstEnterValue || '');
  const [enterSecondValue, setEnterSecondValue] = useState(secondEnteredValue || '');
  
  const [selectedFilterColumns, setSelectedFilterColumns] = useState(
    firstColumn && firstColumn !== "" ? firstColumn : columnsDataValues[0]
  );
  const [selectColumn, setSelectColumn] = useState(
    filterColumn && filterColumn !== "" ? filterColumn : columnsDataValues[0]
  );
  console.log("filterColumn::11", filterColumn, selectColumn)
  //alert(JSON.stringify(selectedFilterColumns)+"selectedFilterColumns"+firstColumn+"firstColumn");
  const [compareType, setCompareType] = useState(
    firstCompareToValue !== undefined ? firstCompareToValue :
      dropdownCompareToOptions[0].symbol);
  const [isConnectionMade, setIsConnectionMade] = useState(connectionValue);

  const [selectedGroupColumns, setSelectedGroupColumns] = useState(

    selectedGroupColumnValue.length > 0 ? selectedGroupColumnValue : ['']
  );

  const [additionalCompareType, setAdditionalCompareType] = useState(
    additionalCompareTypeValues && additionalCompareTypeValues.length > 0 ? additionalCompareTypeValues : dropdownCompareToOptions[0].symbol
  );
  const [showAdditionalGroupInputs, setShowAdditionalGroupInputs] = useState([]);
  const [additionalTextboxValues, setAdditionalTextboxValues] = useState([]);
  const [additionalSecondTextboxValues, setAdditionalSecondTextboxValues] = useState([]);
  const [additionalLogicalOperators, setAdditionalLogicalOperators] = useState(
    additionalLogicalOperatorsValue && additionalLogicalOperatorsValue.length > 0 ? additionalLogicalOperatorsValue : dropdownLogicalOperator[0]["value"]

  );

  const [inputType, setInputType] = useState(getInputType(selectedFilterColumns));
  const isBetweenComparison = compareType === 'BETWEEN'; // Check if the selected comparison is "Between"
  const isBetweenAdditionalComparison = additionalCompareType === 'BETWEEN';

  // Function to determine the input type based on the selected column
  function getInputType(selectedColumnName) {
    // Find the data type for the selected column in columnTypeList
    console.log("columnTypeList:11", columnTypeList)
    if (columnTypeList!=undefined) {
    const dataType = columnTypeList.find((column) => column[0] === selectedColumnName);

    // Check the data type and set the input type accordingly
    if (dataType && dataType[1] === "integer") {
      return "number"; // Set input type to number for integer columns
    } else if (dataType && dataType[1] === "date") {
      return "date"; // Set input type to date for date columns
    }
    else {
      return "text"; // Set input type to text for other columns
    }
  }
}


  function currentAndPreviousTablesAreEqual(previouseTable, currentTable) {

    // Check if both tables are undefined
    if (previouseTable === undefined && currentTable === undefined) {
      return true;
    }

    // Check if one of the tables is undefined and the other is not
    if (previouseTable === undefined || currentTable === undefined) {
      return false;
    }
    if (previouseTable.length !== currentTable.length) {
      return false;
    }

    for (let i = 0; i < currentTable.length; i++) {
      if (previouseTable[i] !== currentTable[i]) {
        return false;
      }
    }

    return true;
  }

  useEffect(() => {
    setName(nodeName);
    setSelectedFilterColumns(selectedFilterColumns);
    setCompareType(compareType);
    setEnterValue(firstEnterValue);
    // setAdditionalTextboxValues();
    setIsConnectionMade(connectionValue);
    setSelectedGroupColumns(selectedGroupColumnValue);

    if (currentAndPreviousTablesAreEqual(selectedPreviousTable, selectedCurrentTable)) {

      setShowAdditionalGroupInputs(showAdditionalinputGrouplength > 0 ? [{}] : []);

      setAdditionalCompareType(additionalCompareTypeValues);
      setAdditionalTextboxValues(groupEnterValue || []);
      setAdditionalLogicalOperators(additionalLogicalOperatorsValue);
      setSelectedFilterColumns(selectedFilterColumns);
    } else {
      setShowAdditionalGroupInputs([]);
      setSelectedGroupColumns([]);
      setEnterValue('');
    }
    // setShowAdditionalGroupInputs(showAdditionalinputGrouplength > 0 ? [{}] : []);
  }, [nodeName, firstColumn, firstCompareToValue, firstEnterValue,
    connectionValue,
    selectedGroupColumnValue, showAdditionalinputGrouplength, additionalCompareTypeValues,
    groupEnterValue, additionalLogicalOperatorsValue]
  );

  const renderAdditionalGroupInputs = () => {
    if (showAdditionalGroupInputs.length > 0) {
      return selectedGroupColumns.map((column, index) => (
        //return showAdditionalGroupInputs.map((input, index) => (
        //  return selectedGroupColumns.map((column, index) => (
        <div key={index} className="additional-input">
          {/* Render your additional inputs here */}
          <div className="form-group">
            <label htmlFor={`dropdown-${index}`}>Group Separator</label>
            <select
              id={`dropdown-${index}`}
              className="form-control"
              value={additionalLogicalOperators[index]}
              onChange={(event) => handleLogicalOperatorChange(event, index)}
            >
              {dropdownLogicalOperator.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor={`dropdown-${index}`}>Column</label>
            <select
              id={`dropdown-${index}`}
              className="form-control"
              value={selectedGroupColumns[index]}
              onChange={(event) => handleGroupColumnChange(event, index)}
            >
              {renderColumnOptions()}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor={`dropdown-${index}`}>Compare Type</label>
            <select id={`dropdown-${index}`} className="form-control"
              value={additionalCompareType[index]}
              onChange={(event) => handleFilterGroupChange(event, index)}>
              {/* {dropdownCompareToOptions.map((option) => (
                <option key={option.value} value={option.symbol}>
                  {option.label}
                </option>
              ))} */}
              {optionCompareTypeElements}
            </select>

          </div>
          <div className="form-group">

            {/* <input type={inputType} value={additionalTextboxValues[index]}
              className="form-control" id={`textbox-${index}`}
              onChange={(event) => handleTextboxChange(event, index)} /> */}
            <input value={additionalTextboxValues[index]}
              className="form-control" id={`textbox-${index}`}
              onChange={(event) => handleTextboxChange(event, index)} />
          </div>
          {/* {additionalCompareType[index] === 'BETWEEN' && inputType !== 'text' && (
            <div className="form-group">
              <label htmlFor="dropdown">Second Value</label>
              <input
                type={inputType}
                value={additionalSecondTextboxValues[index]}
                onChange={(event) => handleSecondTextboxChange(event, index)}
                className="form-control"
                id="upper-bound-textbox"
              />
            </div>
          )} */}
          {additionalCompareType[index] === 'BETWEEN' && (
            <div className="form-group">
              <label htmlFor="dropdown">Second Value</label>
              <input

                value={additionalSecondTextboxValues[index]}
                onChange={(event) => handleSecondTextboxChange(event, index)}
                className="form-control"
                id="upper-bound-textbox"
              />
            </div>
          )}
          <div className="form-group">
            <button
              id="addanother"
              type="button"
              className="btn btn-warning"
              onClick={() => handleRemoveClick(index)}
            >
              Remove
            </button>
          </div>
        </div>
      ));
    }
    return null;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(enterValue);
    let selectedFilterColumnsAppend;
    let selectedGroupColumnsAppend = [];
    let displayValue = '';  
    let parts = '';

    console.log("selectedFilterColumns::1",JSON.stringify(selectedFilterColumns), connectionType);
  
    /*
    selectedFilterColumns.forEach((element, index) => {
      selectedFilterColumns[index] = "json_extract_scalar(" + element + ")"; // Update element at index
    });
    console.log(JSON.stringify(selectedFilterColumns) + "selectedFilterColumns");
    */
    console.log("selectedFilterColumnsAppend::1", windowFunctionWithCondition);
    
    if (windowFunctionWithCondition && windowFunctionWithCondition.length > 0) {
      // Check if the column is present in windowFunctionWithCondition
      // Iterate over the outer array
      console.log("selectedFilterColumnsAppend::2", windowFunctionWithCondition);
      for (let i = 0; i < windowFunctionWithCondition.length; i++) {
        const innerArray = windowFunctionWithCondition[i];
        console.log("selectedFilterColumnsAppend::2.5", innerArray.length);
        // Iterate over the inner array
        for (let j = 0; j < innerArray.length; j++) {
          const item = innerArray[j];
          console.log("selectedFilterColumnsAppend::2.65", item, selectedFilterColumns);
          if (typeof item === 'string' && item.endsWith(` AS ${selectedFilterColumns}`)) {
          //if (typeof item === 'string') {
            selectedFilterColumnsAppend = item.split(" AS ")[0];
            console.log("selectedFilterColumnsAppend::2.75", selectedFilterColumnsAppend);
            //break; // Exit the loop when a match is found
          }
        }
        
        //selectedFilterColumns = selectedGroupColumns;
        console.log("selectedFilterColumnsAppend::2.85", selectedFilterColumnsAppend)

        if (!selectedFilterColumnsAppend) {
          //if (!selectedFilterColumns) {
          // Use a loop to check each array in `columns`f
          console.log("selectedFilterColumnsAppend::4", columns)
          for (let i = 0; i < columns.length; i++) {
            if (columns[i].some(column => selectedFilterColumns.includes(column))) {
              if (connectionType !== 'SQLite') {
                // Use values from the current array
                selectedFilterColumnsAppend = selectedFilterColumns;
                console.log("selectedFilterColumnsAppend::5", JSON.stringify(selectedFilterColumnsAppend), JSON.stringify(selectedFilterColumns));
              } else {
                // Use values from the current array
                parts = selectedFilterColumns.split('.');
                displayValue = selectedFilterColumns;

                if (parts.length === 4) {
                  displayValue = parts.slice(2).join('.');
                }
                else if (parts.length === 2) {
                  displayValue = selectedFilterColumns;
                } else {
                  displayValue = selectedFilterColumns;
                }
                // Use values from the current array
                selectedFilterColumnsAppend = displayValue;
                console.log("selectedFilterColumnsAppend::9",JSON.stringify(selectedFilterColumnsAppend));
              }
              break; // Exit the loop when a match is found
            }
          }
        }
      }
    }
    else {
      // Use a loop to check each array in `columns`
      for (let i = 0; i < columns.length; i++) {
        if (columns[i].some(column => selectedFilterColumns.includes(column))) {
          if (connectionType !== 'SQLite') {
            // Use values from the current array
            selectedFilterColumnsAppend = selectedFilterColumns;
            console.log("selectedFilterColumnsAppend::10",JSON.stringify(selectedFilterColumnsAppend));
          } else {
            const parts = selectedFilterColumns.split('.');
            let displayValue = selectedFilterColumns;

            if (parts.length === 4) {
              displayValue = parts.slice(2).join('.');
            }

            // Use values from the current array
            selectedFilterColumnsAppend = displayValue;
            console.log(JSON.stringify(selectedFilterColumnsAppend) + "selectedFilterColumnsAppend");

          }

          break; // Exit the loop when a match is found
        }
      }

    }

    console.log("selectedFilterColumnsAppend::11", JSON.stringify(selectedGroupColumns));
    if (selectedGroupColumns && selectedGroupColumns.length > 0) {
      
      console.log("selectedFilterColumnsAppend::11.5", windowFunctionWithCondition);
      if (windowFunctionWithCondition && windowFunctionWithCondition.length > 0) {
        console.log("selectedFilterColumnsAppend::11.75", selectedGroupColumns);
        // Check if the column is present in windowFunctionWithCondition
        // const match = windowFunctionWithCondition.find((item) => item.endsWith(` AS ${selectedGroupColumns}`));

        // Iterate over the outer array
        for (let i = 0; i < windowFunctionWithCondition.length; i++) {
          const innerArray = windowFunctionWithCondition[i];

          // Iterate over the inner array
          for (let j = 0; j < innerArray.length; j++) { 
            const item = innerArray[j];

            if (typeof item === 'string' && item.endsWith(` AS ${selectedGroupColumns}`)) {
              console.log("selectedFilterColumnsAppend::12", JSON.stringify(item));
              selectedGroupColumnsAppend = item.split(" AS ")[0];
              break; // Exit the loop when a match is found
            }
          }

          console.log("selectedFilterColumnsAppend::12.5", selectedGroupColumnsAppend);
          if (!selectedGroupColumnsAppend) {
            // Use a loop to check each array in `columns`
            for (let i = 0; i < columns.length; i++) {
              if (columns[i].some(column => selectedGroupColumns.includes(column))) {
                if (connectionType !== 'SQLite') {
                  // Use values from the current array
                  selectedGroupColumnsAppend = selectedGroupColumns;
                  console.log(JSON.stringify(selectedGroupColumnsAppend) + "selectedFilterColumnsAppend");
                } else {
                  // Use values from the current array

                  parts = selectedGroupColumns.split('.');
                  displayValue = selectedGroupColumns;

                  if (parts.length === 4) {
                    displayValue = parts.slice(2).join('.');
                  }

                  // Use values from the current array
                  selectedGroupColumnsAppend = displayValue;

                  console.log(JSON.stringify(selectedGroupColumnsAppend) + "selectedFilterColumnsAppend");
                }

                break; // Exit the loop when a match is found
              }
            }

            // If no match is found, use values directly
            if (!selectedGroupColumnsAppend) {
              selectedGroupColumnsAppend = `${selectedCurrentTable[0]}.${selectedFilterColumns}`;
            }
          }
        }
      }
      
      else {
        for (let i = 0; i < columns.length; i++) {
          if (columns[i].some(column => selectedGroupColumns.includes(column))) {
            if (connectionType !== 'SQLite') {
              // Use values from the current array
              selectedGroupColumnsAppend = selectedGroupColumns;

              console.log("selectedGroupColumnsAppend::100",JSON.stringify(selectedGroupColumnsAppend));
            } else {
              // Use values from the current array
              // selectedGroupColumnsAppend = selectedGroupColumns;
              console.log("selectedSortColumnsAppend::200",JSON.stringify(selectedGroupColumnsAppend));

              const parts = selectedGroupColumns.split('.');
              let displayValue = selectedGroupColumns;

              if (parts.length === 4) {
                displayValue = parts.slice(2).join('.');
              }

              // Use values from the current array
              selectedGroupColumnsAppend = displayValue;
              console.log(JSON.stringify(selectedGroupColumnsAppend) + "selectedFilterColumnsAppend");

            }
            break; // Exit the loop when a match is found
          }
        }

        // If no match is found, use values directly
        if (!selectedGroupColumnsAppend) {
          selectedGroupColumnsAppend = `${selectedCurrentTable[0]}.${selectedGroupColumns}`;

        }
      }
    }
    // Add the first column of selectFiltercolumns to selectGroupColumns
    // const combinedFilterColumns = [selectedFilterColumnsAppend, ...selectedGroupColumnsAppend];
    //const combinedFilterColumns = [selectedFilterColumnsAppend].concat(selectedGroupColumnsAppend);
    const combinedFilterColumns = [selectedFilterColumns].concat(selectedGroupColumns)
    const combinedCompareType = [compareType, ...additionalCompareType];
    const combinedEntervalues = [enterValue, ...additionalTextboxValues];
    const combinedSecondEntervalues = [enterSecondValue, ...additionalSecondTextboxValues];
    const logicalOperators = ['', ...additionalLogicalOperators];
    const buildWhere = {
      groupSeparator: [{ sep: buttonValue }],
      group: []
    };
    console.log("columnData::200", combinedFilterColumns);
    for (let i = 0; i < combinedFilterColumns.length; i++) {
      const combinedFilterColumn = combinedFilterColumns[i];
      const comparisonOperator = combinedCompareType[i];
      const value = combinedEntervalues[i];
      let value2 = ''; // Initialize value2

      // if (comparisonOperator === 'BETWEEN') {
      //   // If comparisonOperator is "Between," assign value2
      //   value2 = combinedSecondEntervalues[i];
      // }


      const columnData = {
        logicalOperator: i > 0 ? logicalOperators[i] : '', // Use the logical operator based on the index
        column: combinedFilterColumn,
        comparisionOperator: comparisonOperator,
        value: value
        // value: inputType === 'text' || inputType === 'date' ? "'" + value + "'" : value
        // value: inputType === 'text' || inputType === 'date' ? (inputType === 'date' ? `DATE '${value}'` : `'${value}'`) : value
      };
      // Conditionally add value2 for "Between" comparison
      if (comparisonOperator === 'BETWEEN') {
        value2 = combinedSecondEntervalues[i];
        // columnData.value2 = inputType === 'text' || inputType === 'date' ? (inputType === 'date' ? `DATE '${value2}'` : `'${value2}'`) : value2;
        columnData.value2 = value2;

      }
      console.log("columnData::1",JSON.stringify(columnData));
      if (connectionType == "kafka" && columnData["column"].includes("_message_") && !columnData["column"].includes("CAST")) {
        //json_extract_scalar(kafka_test.tpch.customer._message_rowNumber)
        const name = columnData["column"].split("_message_")
        columnData["column"] = "json_extract_scalar(" + name[0] + "_message" + ", '$." + name[1] + "')"
        console.log(JSON.stringify(columnData) + "columnData", dropdownLogicalOperator[0].value);
      }

      buildWhere.group.push(columnData);

    }

    // alert(buildWhere);

    const data = [{ buildWhere: JSON.stringify(buildWhere) }];
    const jsonString = JSON.stringify(data);
    console.log("buildWhere::1", jsonString);
    // Convert the JSON object to string
    const jsonFilterData = JSON.stringify({ buildWhere });

    console.log(jsonFilterData);

    const dataFilterJson =
      { groupSeparator: buildWhere.groupSeparator, group: buildWhere.group };

    console.log("dataFilterJson::1",JSON.stringify(dataFilterJson))
    filterColumn = selectColumn;
    console.log("filterColumn::12", filterColumn, selectedFilterColumns) 
    const showAdditionalinputGrouplength = showAdditionalGroupInputs.length;
    onValueSubmit(selectedNodeId, name, compareType, selectedCurrentTable,
      selectedFilterColumns, enterValue, enterSecondValue, additionalTextboxValues,
      selectedGroupColumns, additionalCompareType, showAdditionalinputGrouplength,
      additionalLogicalOperators, dataFilterJson,filterColumn
    );
  };
  
  const handleRemoveTable = () => {
    // Call the onRemoveTable callback function
    var newNodes = []
    var newEdges = []
    var newDroppedNodes = []
    //console.log("onRemoveTable::1", nodes[0]["id"], selectedNodeId)
    if (onRemoveTable) {
      newNodes = nodes.filter((node) => node["id"] != selectedNodeId);
      newEdges = edges.filter((edge) => !edge["id"].includes(`-${selectedNodeId}`));
      //edataTable_1-
      for (let i = 0; i < droppedNodes.length; i++) {
        if (droppedNodes[i] === selectedNodeId) {
          droppedNodes.splice(i, 1);
          console.log("Remaining elements: " + droppedNodes);
        }
      }
      //newDroppedNodes = droppedNodes.filter(!selectedNodeId)
      console.log("onRemoveTable::2", newNodes, selectedNodeId, edges, newEdges, newDroppedNodes)
      onRemoveTable();
    }
    // Close the popup
    setNodes(newNodes)
    setEdges(newEdges)
    setDroppedNodes(droppedNodes)
    //onClose(nodes)
  };


  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleLinkClick = () => {
    // Perform any actions when the link is clicked
    // ...
  };
  // Function to update the dynamic value
  const handleNameChange = (event) => {

    setName(event.target.value);

  };

  // Function to update the dynamic value
  const handleEnterValue = (event) => {
    const enterVal = event.target.value;
    setEnterValue(enterVal);

  };

  // Function to update the dynamic value
  const handleSecondValue = (event) => {
    const enterVal = event.target.value;
    setEnterSecondValue(enterVal);

  };

  const handleTextboxChange = (event, index) => {
    const { value } = event.target;

    setAdditionalTextboxValues((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = value;
      return updatedValues;
    });
  };
  const handleSecondTextboxChange = (event, index) => {
    const { value } = event.target;

    setAdditionalSecondTextboxValues((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = value;
      return updatedValues;
    });
  };


  const handleFilterChange = (event) => {
    setCompareType(event.target.value);
    console.log(compareType);
  };

  const handleFilterGroupChange = (event, index) => {
    const { value } = event.target;

    setAdditionalCompareType((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = value;
      return updatedValues;
    });
  };


  // Filter the options based on inputType
  const filteredCompareTypeOptions = dropdownCompareToOptions.filter((option) => {
    // Exclude the "Between" option if the input type is "text"
    // if (inputType === 'text' && option.value === 'Between') {
    //   return false;
    // }
    if (option.value === 'Between') {
      return false;
    }
    return true; // Include all other options
  });

  // Map the filtered options to select elements
  const optionCompareTypeElements = filteredCompareTypeOptions.map((option) => (
    <option key={option.value} value={option.symbol}>
      {option.label}
    </option>
  ));

  function moveToFirstIndex(totalColumns, selectedFilterColumn) {
    // Remove the column if it exists in the array
    const index = totalColumns.indexOf(selectedFilterColumn);
    if (index > -1) {
      totalColumns.splice(index, 1); // Remove the column
    }
    // Add the column to the start of the array
    totalColumns.unshift(selectedFilterColumn);
    return totalColumns;
  }


 let windowAliasColumns = []
  const renderColumnOptions = () => {
    if (selectedCurrentTable) {
      /*
      windowFunctionWithCondition.map((column) =>{
        console.log("filterAliasColumn::1", column[0].split('AS'))
        const aliasCol = column[0].split('AS')
        windowAliasColumns.push(aliasCol[aliasCol.length - 1].trim())
      })
      */
      console.log("filterAliasColumn::0", selectedCurrentTable,  JSON.stringify(windowFunctionWithCondition))
      windowFunctionWithCondition.map((column) => {
        console.log("filterAliasColumn::1", JSON.stringify(column), columnsDataValues)
        column.map((col) => {
        windowAliasColumns.push(col)
        //console.log("filterAliasColumn::105", columnsDataValues.includes(col))
        //if (!columnsDataValues.includes(col)) {
          //windowAliasColumns.push(col)
        //}
      }
      )})
      //windowAliasColumns = new Set(windowAliasColumns);
      //let windowColumns=[];
      console.log("selectColumn::125", selectColumn)
      /*
      for (let i = 0; i < windowAliasColumns.length; i++){
        console.log("filterAliasColumn::125", windowAliasColumns[i])
        if (!columnsDataValues.includes(windowAliasColumns[i])) {
          windowColumns.push(windowAliasColumns[i])
          console.log("filterAliasColumn::150", windowColumns)
        } 
      }
      
      for (let i = 0; i < windowAliasColumns.length; i++) {
        console.log("filterAliasColumn::125", windowAliasColumns[i])
      }
      
      windowAliasColumns.map((value)=> {
        if (columnsDataValues.includes(value)) {
          windowAliasColumns = windowAliasColumns.filter(val => val !== value);
        }
      })
      */
      
      let totalColumns = [...columnsDataValues, ...new Set(windowAliasColumns)]
      //const totalColumns = [...new Set(windowAliasColumns), ...columnsDataValues]
      //const totalColumns = [...columnsDataValues, ...windowColumns]
      //console.log("filterAliasColumn::200",windowAliasColumns,columnsDataValues,totalColumns)
      //`totalColumns = moveToFirstIndex(totalColumns, selectedFilterColumns)
      console.log("selectedColumnName::11",selectColumn)
      let parts   
      const columnOptions = totalColumns.map((column) => {
        if (column.includes('CAST')) {
          const aliasCol = column.split('AS')
          parts = aliasCol[aliasCol.length - 1].trim().split  ('.')
          const col = column.split('AS _message')
          column = col[0].trim()
          console.log("filterAliasColumn::3", column, aliasCol, parts)

        } else {
          parts = column.split('.');
          console.log("filterAliasColumn::4", column,parts)
        }
        const displayValue = parts.length === 4
          ? parts[3]
          : parts.length === 1
            ? parts[0]
            : parts[1];
        console.log("filterAliasColumn::5",displayValue)
        return (
          <option key={column} value={column}>
            {displayValue}
          </option>
        );
      });

      // Add aliasColumn as an additional option, filtering out empty or null values
      if (aliasColumn && aliasColumn.length > 0) {
        console.log("filterAliasColumn::51", aliasColumn)
        aliasColumn
          .flat(Infinity) // Flatten the array to handle nested arrays of any depth
          .filter((value) => value !== "" && value !== null) // Filter out empty strings and null values
          .forEach((value, index) => {
            columnOptions.push(
              <option key={index} value={value}>
                {value}
              </option>
            );
          });
      }
      return columnOptions;
    }
    return null;
  };

  const handleAddAnotherClick = () => {
    //alert(JSON.stringify(additionalLogicalOperators) + "additionalLogicalOperators");
    console.log("additionalLogicalOperators::1", dropdownLogicalOperator[0]["value"], additionalLogicalOperators)
    const newAdditionalLogicalOperators = [additionalLogicalOperators, dropdownLogicalOperator[0].value];
    console.log("additionalLogicalOperators::2", newAdditionalLogicalOperators)
    const newSelectedGroupColumns = [...selectedGroupColumns, selectedFilterColumns];
    console.log("newSelectedGroupColumns::1",JSON.stringify(newSelectedGroupColumns));
    const newAdditionalCompareType = [...additionalCompareType, dropdownCompareToOptions[0].symbol];
    console.log(JSON.stringify(newAdditionalLogicalOperators) +    +
      JSON.stringify(newSelectedGroupColumns) + "---" +
      JSON.stringify(newAdditionalCompareType) + "---");
    setAdditionalCompareType(newAdditionalCompareType);
    setSelectedGroupColumns(newSelectedGroupColumns);
    setAdditionalLogicalOperators(newAdditionalLogicalOperators);

    setSelectedGroupColumns(selectedGroupColumns => [...selectedGroupColumns]);
    setAdditionalTextboxValues(additionalTextboxValues => [...additionalTextboxValues]);
    setAdditionalLogicalOperators(additionalLogicalOperators => [...additionalLogicalOperators]);
    setAdditionalCompareType(additionalCompareType => [...additionalCompareType]);

    setShowAdditionalGroupInputs([...showAdditionalGroupInputs, {}]);

  };


  const handleRemoveClick = (index) => {
    setSelectedGroupColumns((prevColumns) => {
      const updatedColumns = [...prevColumns];
      updatedColumns.splice(index, 1);
      return updatedColumns;
    });


  };

  const handleColumnChange = (event) => {
    //const selectedColumnName = event.target.value.split(":")[1];
    const selectedColumnName = event.target.value;
    //console.log("selectedColumnName::12", event.target.value.split(":"));
    setSelectColumn(event.target.value);
    console.log("selectedColumnName::121", selectColumn);
    setSelectedFilterColumns(selectedColumnName); 
    console.log("selectedColumnName::2", selectedFilterColumns);
    setInputType(getInputType(selectedColumnName));
    console.log("selectedColumnName::3", inputType);
    setEnterValue(""); // Reset the entered value when the column changes
    //setSelectedFilterColumns(selectedColumnName)
  };
  

  const handleGroupColumnChange = (event, index) => {

    const { value } = event.target;
    console.log("handleGroupColumnChange::1", value, selectedGroupColumns,index)
    // Update the selectedThenByColumns state with the selected value
    const updatedColumns = [...selectedGroupColumns];
    console.log("handleGroupColumnChange::2", updatedColumns)
    updatedColumns[index] = value;
    console.log("handleGroupColumnChange::3", updatedColumns)
    setSelectedGroupColumns(updatedColumns);
    console.log("handleGroupColumnChange::4", selectedGroupColumns)
    const selectedAdditionalColumnName = value;
    const inputType = getInputType(selectedAdditionalColumnName);
    setInputType(inputType);
    setEnterSecondValue("");
  };
  const handleLogicalOperatorChange = (event, index) => {
    console.log("updatedLogicalOperators::1", event.target.value )
    // alert(JSON.stringify(additionalLogicalOperators) + "additionalLogicalOperators");
    const updatedOperators = [...additionalLogicalOperators];
    updatedOperators[index] = event.target.value;
    setAdditionalLogicalOperators(updatedOperators);
  };



  return (
    <div className="overlay">

      <div className="popup-datatable">
        <div className="popup-header">
          <h4 class='modal-title'>Tool Options</h4>
          <button className="close-button" onClick={onClose}>

            <span>&times;</span>
          </button>
        </div>
        <div className="datatable-content">
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="textbox">Filter </label>
              <input type="text" value={name} onChange={handleNameChange}
                className="form-control" id="textbox" />
            </div>

            <div className="form-group">
              <label htmlFor="dropdown">Column</label>
              <select
                id="dropdown"
                className="form-control"
                value={selectColumn}
                onChange={handleColumnChange}
              >
                {renderColumnOptions()}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="dropdown">Compare Type</label>

              <select id="filterDropdown" className="form-control"
                value={compareType} onChange={handleFilterChange}>
                {optionCompareTypeElements}

              </select>
            </div>
            {isConnectionMade && (
              <>
                <div className="form-group">
                  <label htmlFor="dropdown">Compare Value</label>

                  <div className="form-group">

                    {/* <input type={inputType} value={enterValue} onChange={handleEnterValue}
                      className="form-control" id="textbox" /> */}
                    <input value={enterValue} onChange={handleEnterValue}
                      className="form-control" id="textbox" />
                  </div>
                </div>

                {/* {isBetweenComparison && inputType !== 'text' && (
                  <div className="form-group">
                    <label htmlFor="dropdown">Second Value</label>
                    <input
                      type={inputType}
                      value={enterSecondValue}
                      onChange={handleSecondValue}
                      className="form-control"
                      id="upper-bound-textbox"
                    />
                  </div>
                )} */}
                {isBetweenComparison && (
                  <div className="form-group">
                    <label htmlFor="dropdown">Second Value</label>
                    <input
                      value={enterSecondValue}
                      onChange={handleSecondValue}
                      className="form-control"
                      id="upper-bound-textbox"
                    />
                  </div>
                )}

                {renderAdditionalGroupInputs()}
                <div className="form-group">
                  <button type='button' className='btn btn-primary' onClick={handleAddAnotherClick}>
                    Add Another
                  </button>
                </div>

              </>

            )}
            <div className="form-group toolHelpLink">
              <a href="https://example.com" target="_blank" onClick={handleLinkClick}>
                How does this tool work?
              </a>
            </div>
          </div>
          <div className="modal-footer">
            <button type='button' onClick={handleRemoveTable} class='btn btn-danger remove'>Delete Tool</button>
            <button type='button' className='btn btn-primary ok' onClick={handleSubmit}>OK</button>
          </div>
        </div>
      </div>
    </div>
  );
};



export default FilterPopupComponent;
